export default __webpack_public_path__ + "static/media/guest_12_02_lisiane_lemos.3a906bd2.png";